module.exports = __webpack_public_path__ + "static/media/Sept19-F19.c4f57c73.png";